import { FunctionComponent } from 'react';
import { StreamPageVideo } from './StreamPageVideo';
import { StreamPageVideoWidget } from './StreamPageVideoWidget';

export const StreamPageVideoHeader: FunctionComponent = () => {
  return (
    <div className="h-stack bg-black" style={{ height: '30vmax', maxHeight: '400px' }}>
      <div className="h-full flex-1">
        <StreamPageVideoWidget />
      </div>
      <div className="w-px h-full bg-gray-800"></div>
      <div className="h-full flex-1 overflow-hidden">
        <StreamPageVideo />
      </div>
    </div>
  );
};
